export default __webpack_public_path__ + "static/media/O-067.12f79736.png";